import { secondaryGroupHeaders } from './leaderboard-filter-helpers'

export default function getGroupedHeaders(secondaryGroupBy) {
    return (
        secondaryGroupBy
            // Hack to remove extraneous month column (since we have both month as text and number)
            .filter((d) => d !== 'api_game_date_month_mm')
            .map(
                (col) =>
                    secondaryGroupHeaders[col] || {
                        name: col,
                        field: col,
                        headerClass: `th-component-header align-center th-vertical-bottom table-static-column`,
                        fieldClass: `tr-data align-center table-static-column border-left border-right`,
                    }
            )
    )
}
